const isInputElement = (element, always = false) => {
  return element instanceof HTMLInputElement && (always || element.type !== "hidden" && element.value !== "") || element instanceof HTMLTextAreaElement && (always || element.value !== "") || element instanceof HTMLSelectElement;
};
const isInteractiveRole = (element) => {
  return element instanceof HTMLElement && (element.getAttribute("role") === "button" || element.getAttribute("role") === "link" || element.getAttribute("role") === "menuitem");
};
const isInteractiveElement = (element, always = false) => {
  return element instanceof HTMLAnchorElement || element instanceof HTMLButtonElement || isInteractiveRole(element) || isInputElement(element, always);
};
const getClosestInteractiveElement = (element, always = false) => {
  if (!element) return null;
  if (isInteractiveElement(element, always)) return element;
  return getClosestInteractiveElement(element.parentElement, always);
};
const isEditableElement = (element) => {
  return isInputElement(element) || element instanceof HTMLElement && element.isContentEditable;
};
const isInteractiveElementOrHasInteractiveParent = (element, always = false) => {
  return isInteractiveElement(element, always) || element instanceof HTMLElement && isInteractiveElement(element.closest("a, button, input"), always);
};
const generateSelectorPath = (rootElement, childElement, options) => {
  const {
    includeRootElement = false,
    allowedAttributes = []
  } = options || {};
  if (!rootElement.contains(childElement)) {
    return "";
  }
  if (rootElement === childElement && includeRootElement) {
    return getElementSelector(rootElement, allowedAttributes);
  }
  const path = [];
  let currentElement = childElement;
  while (currentElement) {
    if (currentElement === rootElement) {
      if (includeRootElement) {
        path.push(getElementSelector(currentElement, allowedAttributes));
      }
      break;
    }
    if (currentElement.parentElement) {
      const siblings = Array.from(currentElement.parentElement.children);
      const index = siblings.indexOf(currentElement) + 1;
      let selector = `${currentElement.tagName.toLowerCase()}:nth-child(${index})`;
      if (allowedAttributes.length > 0) {
        selector = addAttributesToSelector(currentElement, selector, allowedAttributes);
      }
      path.push(selector);
    }
    currentElement = currentElement.parentElement;
  }
  path.reverse();
  return path.join(" > ");
};
const getElementSelector = (element, allowedAttributes) => {
  let selector = element.tagName.toLowerCase();
  if (allowedAttributes.length > 0) {
    selector = addAttributesToSelector(element, selector, allowedAttributes);
  }
  return selector;
};
const addAttributesToSelector = (element, selector, allowedAttributes) => {
  let result = selector;
  for (const attr of allowedAttributes) {
    const value = element.getAttribute(attr);
    if (value !== null) {
      result += `[${attr}="${value}"]`;
    }
  }
  return result;
};
const getNearestScrollableParent = (element) => {
  if (!element) return null;
  if (element.scrollHeight > element.clientHeight) return element;
  if (element.parentElement) {
    return getNearestScrollableParent(element.parentElement);
  }
  return null;
};

export { generateSelectorPath, getClosestInteractiveElement, getNearestScrollableParent, isEditableElement, isInputElement, isInteractiveElement, isInteractiveElementOrHasInteractiveParent, isInteractiveRole };
//# sourceMappingURL=index.js.map
